<template>
  <div :style="wrapStyle" @click="handleClickEvent">
    <c-button ref="button" :style="{...bgImageStyle}" v-bind="$props"></c-button>
    <c-dialog
      v-model="showInvitedDialog"
      :option="invitedOption"
      @close="closeShowInvitedDialog"
      @confirm="helpOrInvitedFunc"
      v-transfer-dom
    >
      <template slot="body">
        <div :class="getCss('dialog-content')" v-if="!isHelp">
          <img
            :class="getCss('avatar')"
            v-if="!!inviteInfo.avatar"
            :src="inviteInfo.avatar" alt="">
          <p :class="getCss('invite-user-name')"
             v-if="!!inviteInfo.inviter_name"
             v-html="`${configurationData.inviteNickPreText}&nbsp;${inviteInfo.inviter_name}`"></p>
          <p
            :class="getCss('invite_name')"
            v-html="inviteJoinTips"
          />
          <div :class="getCss('help_gift_img_area')">
            <img v-if="!!helpGiftImage" :class="getCss('help_gift_img')" :src="helpGiftImage" alt/>
          </div>
        </div>
        <div v-else :class="getCss('show-success-invited-text')">
          {{ configurationData.showSuccessInvitedText }}
        </div>
      </template>
      <template slot="footer" v-if="isHelp">
        <div>
          <button
            :style="confirmShowSuccessButtonStyle"
            class="ceiba-dialog-ft-button"
            @click="confirmShowSuccessConfirm()"
          >{{ confirmShowSuccessButtonText }}
          </button>
        </div>
      </template>
    </c-dialog>
    <c-dialog v-model="showSuccessInvitedDialog"
                   :option="successInvitedPopOption"
                   @close="showSuccessInvitedDialog = false"
                   @confirm="showSuccessInvitedDialog = false"
                   @cancel="showSuccessInvitedDialog = false"
                   v-transfer-dom
    >
      <template slot="body">
        <div :class="getCss('reward-tips')" >
          <div>{{ successHelpTip }}</div>
        </div>
      </template>
      <template slot="footer">
        <div>
          <button
            :style="confirmShowSuccessButtonStyle"
            class="ceiba-dialog-ft-button"
            @click="confirmShowSuccessConfirm()"
          >{{ confirmShowSuccessButtonText }}
          </button>
        </div>
      </template>
    </c-dialog>
    <c-dialog
      v-model="showClubInvitedDialog"
      :option="clubInvitedOption"
      @close="closeShowClubInvitedDialog"
      @confirm="ClubInvitedFunc"
      :key="joinedClub"
      v-transfer-dom
    >
      <template slot="body">
        <div :class="getCss('dialog-content')">
          <p
            :class="getCss('invite_name')"
            v-html="inviteJoinTips"
          />
          <img
            :class="getCss('avatar')"
            v-if="inviteInfo.avatar"
            :src="inviteInfo.avatar" alt="">
          <p :class="getCss('invite-user-name')"
             v-html="`${configurationData.inviteNickPreText}&nbsp;${inviteInfo.inviter_name}`"></p>
        </div>
      </template>
    </c-dialog>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { common, componentBaseMixin, baseComponents } from '@tencent/ceiba-base-components';
// import { common, componentBaseMixin, baseComponents } from '../../../../ceiba-base-components';
import button from '@tencent/ceiba-act-public-button';
// import CDialog from '@tencent/ceiba-base-components/src/components/base-dialog';
import CDialog from '@tencent/ceiba-base-components/src/components/ceiba-dialog';
// import CDialog from '.././../../../ceiba-base-components/src/components/ceiba-dialog';


const FORCE_INVITED_DEVICE_INSIDE_APP = 1; // 只能在端内触发应邀
const FORCE_INVITED_DEVICE_OUTSIDE_APP = 2;// 只能在端外触发应邀
const FORCE_INVITED_BOTH_SIDE_DEVICE = 3;//  在端内外触发应邀

const FORCE_SHARE_DEVICE_INSIDE_APP = 1; // 只能在端内分享
// const ForceShareDeviceOutsideApp = 2;// 只能在端外分享
// const ForceShareBothSideDevice = 3;// 同时在端内外分享
export default {
  name: 'CTgclubUserInviteShareWithExtraGuide',
  components: {
    [button.name]: button,
    [CDialog.name]: CDialog,
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'tgclub-user-invite-share-with-extra-guide-',
      // 客态 被邀请的码
      inviteCode: '',
      //  主态 邀请码
      selfInviteCode: '',
      showInvitedDialog: false,
      showSuccessInvitedDialog: false,
      inviteInfo: {
        inviter_name: '',
        avatar: '',
      },
      hasAccessBindInHelpInvited: false,
      showClubInvitedDialog: false, // 加入俱乐部邀请弹窗
      joinedClub: false, // 已加入俱乐部
      isHelp: false,    // 是否助力
    };
  },
  computed: {
    // 是否有资格助力
    isEnabledInvited() {
      const { invitedFlowId  = 0 } = this.configurationData;
      const packageStatus = this.quaInfo[invitedFlowId];
      if (!packageStatus) return true;
      return !(packageStatus.total > 0 && packageStatus.remain === 0);
    },
    successInvitedPopOption() {
      const { successHelpTipPopTitle  =  '' } = this.configurationData;
      const { dialogStyle = {} } = this.dialogConfig;
      return Object.assign({}, this.dialogConfig, {
        header: successHelpTipPopTitle || '温馨提示',
        footer: true,
        confirm: true,
        dialogStyle: this.helpDialogBgImage
          ? {
            ...dialogStyle,
            backgroundImage: `url('${this.helpDialogBgImage}')`,
            ...this.inviteMsgContentStyle,
          }
          : { ...dialogStyle, ...this.inviteMsgContentStyle },
      });
    },
    clubInvitedOption() {
      // 俱乐部邀请弹窗参数
      const { dialogStyle = {} } = this.dialogConfig;
      const extend = {
        footer: true,
        confirm: true,
        header: '',
        dialogStyle: this.helpDialogBgImage
          ? {
            ...dialogStyle,
            backgroundImage: `url('${this.helpDialogBgImage}')`,
            ...this.inviteMsgContentStyle,
          }
          : { ...dialogStyle, ...this.inviteMsgContentStyle },
        confirmStyle: Object.assign(
          {},
          this.joinedClub
            ? {
              width: '2.1rem',
              background: `url('${this.configurationData.joinedClubBtn}')`,
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              margin: '0.1rem 0.4rem',
            }
            : {
              width: '2.1rem',
              background: `url('${this.configurationData.notJoinedClubBtn}')`,
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              margin: '0.1rem 0.4rem',
            },
        ),
        cancel: false,
        // closeLocation: 'bottom-center',
        close: true,
        height: '4.5rem',
        titleStyle: this.inviteHelpPopTitleStyle,
      };
      extend.dialogStyle.height = '4.5';
      return Object.assign({}, this.dialogConfig, extend);
    },
    handleAssistancePopupDisplay() {
      return this.configurationData.handleAssistancePopupDisplay;
    },
    confirmShowSuccessButtonText() {
      return this.configurationData.showSuccessInvitedBgImage ? '' : '确认';
    },
    // 助力成功弹窗按钮
    confirmShowSuccessButtonStyle() {
      console.log(this.configurationData.showSuccessInvitedBgImage, 'this.configurationData.showSuccessInvitedBgImage');
      if (this.configurationData.showSuccessInvitedBgImage) {
        return {
          width: '6.2rem',
          display: 'block',
          height: '0.65rem',
          backgroundImage: `url(${this.configurationData.showSuccessInvitedBgImage})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          margin: '0 0',
        };
      }
      return {
        width: '6.2rem',
        display: 'block',
        height: '0.65rem',
        backgroundColor: '#3b3a3a',
        color: '#fff',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        margin: '0 0',
      };
    },
    invitedOption() {
      const { dialogStyle = {} } = this.dialogConfig;
      const extend = {
        footer: true,
        confirm: this.helpButtonIcon ? true : '帮TA助力',
        header: this.configurationData.helpPopTitle || '邀请助力',
        dialogStyle: this.helpDialogBgImage
          ? {
            ...dialogStyle,
            backgroundImage: `url('${this.helpDialogBgImage}')`,
            ...this.inviteMsgContentStyle,
          }
          : { ...dialogStyle, ...this.inviteMsgContentStyle },
        confirmStyle: Object.assign(
          {},
          this.helpButtonIcon
            ? {
              width: '2.1rem',
              background: `url('${this.helpButtonIcon}')`,
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
              margin: '0.1rem 0.4rem',
            }
            : {
              width: '2.2rem',
              background: '#242424',
              color: '#ffffff',
              margin: '0.1rem 0.4rem',

            },
        ),
        cancel: false,
        // closeLocation: 'bottom-center',
        close: true,
        height: '7.5rem',
        titleStyle: this.inviteHelpPopTitleStyle,
      };
      extend.dialogStyle.height = '7.5';
      return Object.assign({}, this.dialogConfig, extend);
    },
    wrapStyle() {
      const fontStyle = this.styles.fontStyle || {};
      return {
        ...this.styles.base,
        ...fontStyle,
      };
    },
    // 邀请标题的样式
    inviteHelpPopTitleStyle() {
      return this.styles?.inviteHelpPopTitleStyle ?? {};
    },
    // 邀请文案的样式
    inviteMsgContentStyle() {
      const style = this.styles?.inviteMsgContentStyle ?? {};
      if (!style.color) style.color = this.configurationData.invitedTextColor || '#ffffff';
      return style;
    },
    // 按钮背景图
    bgImageStyle() {
      return {
        backgroundImage: `url(${this.configurationData.bgImage || ''})`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        left: 0,
        top: 0,
      };
    },
    // 前置条件判断
    preConditionFlowId() {
      return this.configurationData.preConditionFlowId || 0;
    },
    // 是否需要邀请码
    isInvite() {
      return this.configurationData.isInvite || false;
    },
    // 邀请回调 心悦邀请回调
    callBackFlowId() {
      return this.configurationData.callBackFlowId || 0;
    },
    // begin ###应邀模式####
    isHasSettingInvitedAccess() {
      // isHasInvitedAccess === 0  不需要应邀  | === 1 需要应邀
      const { isHasInvitedAccess =  0 }  = this.configurationData;
      return isHasInvitedAccess  ===  1;
    },
    // 助力或标记流程
    invitedFlowId() {
      return this.configurationData.invitedFlowId || 0;
    },
    helpGiftImage() {
      return this.configurationData.helpGiftImage || '';
    },
    // 助力icon
    helpButtonIcon() {
      return this.configurationData.helpButtonIcon || '';
    },
    helpDialogBgImage() {
      return this.configurationData.helpDialogBgImage || '';
    },
    successHelpTip() {
      return this.configurationData.successHelpTip || '助力成功!';
    },
    inviteJoinTips() {
      if (this.configurationData.isClubInvite) {
        return this.joinedClub ? this.configurationData.inviteJoinedClubTips : this.configurationData.inviteJoinTips;
      }
      return this.configurationData.inviteJoinTips || '邀请帮助TA领取专属福利';
    },
    isIOS() {
      return this.$platform.isIos;
    },
    // 判断是否在app内邀请
    forceAppShare() {
      const { forceDeviceInviteType = 1 } = this.configurationData;
      return forceDeviceInviteType === FORCE_SHARE_DEVICE_INSIDE_APP;
    },
  },
  async mounted() {
    console.log(' tgclub-user-invite-share-with-extra-guide configurationData=', this.configurationData);
    await this.initialize();
  },
  methods: {
    // 判断邀
    async handleInvitePreCondition() {
      if (this.preConditionFlowId <= 0) {
        return true;
      }
      const response = await this.flowRequest({
        flowId: this.preConditionFlowId,
        params: {
          role: this.roleInfo,
        },
      });
      console.log('邀请或助力 pre condition check =', response);
      const { ret = 0, msg, data = {} } = response;
      const { ret: rspRet = 0, msg: rspMsg } = data;

      if (ret !== 0 || rspRet !== 0) {
        this.$alert({ msg: msg || rspMsg || '不满足邀请条件' });
        return false;
      }
      this.refreshQua(); // 刷新资格
      return true;
    },
    // 关闭应邀
    closeShowInvitedDialog() {
      this.showInvitedDialog = false;
    },
    // 打开应邀
    openShowInvitedDialog() {
      const { delayShowInvitedDialog = 0 } = this.configurationData;
      // 是否延迟弹窗
      setTimeout(() => {
        this.showInvitedDialog = true;
      }, delayShowInvitedDialog * 1000);
    },
    // 关闭俱乐部应邀
    closeShowClubInvitedDialog() {
      this.showClubInvitedDialog = false;
    },

    async ClubInvitedFunc() {
      // 俱乐部应邀模式弹窗确认按钮
      // 如果没在app,跳app
      if (this.configurationData.forceApp && !this.$ast.isAPP()) {
        // 如果没有跳转链接,直接跳app活动页
        if (!this.configurationData.jumpUrl) {
          this.$ast.gotoAPP();
          return;
        }
        this.$ast.gotoAPP(this.configurationData.jumpUrl);
        return;
      }
      // 如果未加入俱乐部
      if (!this.joinedClub) {
        // 应邀
        const response = await this.flowRequest({
          flowId: this.configurationData.invitedFlowId,
          params: {
            role: this.roleInfo,
            data: JSON.stringify({
              inviteCode: this.inviteCode,
              name: this.userInfo.nickName ? encodeURIComponent(this.userInfo.nickName) : '',
              avatar: this.userInfo.avatar,
            }),
          },
        });
        const { ret, msg, data = {} } = response;
        if (ret !== 0) {
          this.$alert({ msg });
          this.reportFunc('assist', { status: '0' });
          return false;
        }
        const { ret: resRet, msg: resMsg } = data;
        if (resRet !== 0) {
          this.$alert({ msg: resMsg });
          this.reportFunc('assist', { status: '0' });
          return false;
        }

        this.refreshQua(); // 刷新资格
        this.closeShowClubInvitedDialog();
        this.reportFunc('assist', { status: '1' });

        // 受邀后触发加入俱乐部
        if (this.configurationData.isTriggerJoinClub) {
          this.$eventBus.$emit('ceiba:common:events:trigger-join-club-button', {});
          this.showClubInvitedDialog = false;
          this.showInvitedDialog = false;
        }

        // 接受邀请加入俱乐部成功
        if (this.configurationData.withoutShowSuccessInvitedDialog === true) {
          console.log('不需要助力成功的弹窗');
        } else {
          this.showSuccessInvitedDialog = true;
        }

        // 如果没有跳转链接,直接关弹窗
        if (!this.configurationData.jumpUrl) {
          this.showClubInvitedDialog = false;
          this.showInvitedDialog = false;
          return false;
        }
        // 如果有跳转链接,跳转
        setTimeout(() => {
          let link = this.configurationData.jumpUrl;
          // 当打开的活动url上携带了via,via_source,trace_id参数时，透传当前活动的via,via_source,trace_id到分享链接上
          link = common.tool.passThroughUrlParam(link, ['via', 'trace_id', 'via_source']);
          window.location.href = link;
        }, 500);
        this.showClubInvitedDialog = false;
        this.showInvitedDialog = false;
      }
      // 如果已加入俱乐部,
      this.showClubInvitedDialog = false;
      this.showInvitedDialog = false;
    },

    //  助力或应邀模式
    async  helpOrInvitedFunc() {
      // 不是应邀模式
      if (!this.isHasSettingInvitedAccess) {
        console.log('当前不是应邀模式', this.isHasSettingInvitedAccess);
        return false;
      }

      console.log('invitedFlowId', this.invitedFlowId);
      if (this.invitedFlowId <= 0) {
        this.closeShowInvitedDialog();
        return false;
      }

      const { helpOrInvitedForceRole = false, withoutShowSuccessInvitedDialog = false } = this.configurationData;
      console.log('helpOrInvitedForceRole is forceRole', helpOrInvitedForceRole);
      //   绑定角色
      // 助力没有绑定角色  设置hasAccessBindInHelpInvited 防止多次弹框
      if (helpOrInvitedForceRole === true && !this.isRoleReady && this.hasAccessBindInHelpInvited === false) {
        const self = this;
        try {
          this.closeShowInvitedDialog();
          this.$onRoleReady(async () => {
            if (this.isRoleReady && !this.accessHelpOrInvitedAfterBind) {
              this.accessHelpOrInvitedAfterBind = true;
              this.HandleInviteCode();
            }
          });
          baseComponents.gameRoleSelect.showGameRoleSelect(this.currentGameCode || this.actInfo.game_code, {})
            .then((roleInfo) => {
              console.log('store select role=', roleInfo);
              self.$store.dispatch('saveCurrentRole', {
                isRoleReady: true,
                roleInfo,
              });
            });
          // 绑定助力需要角色
        } catch (e) {
          console.error('showGameRoleSelect fail| err=', e);
        }
        this.hasAccessBindInHelpInvited = true;
        return;
      }
      const inviteCode = common.tool.getQueryparams('c_invite_code') || '';
      const { forbiddenRequireRole = false } =  this.configurationData;
      // 助力
      const  response   = await  this.flowRequest({
        flowId: this.invitedFlowId,
        params: {
          role: forbiddenRequireRole ? {} : this.roleInfo,
          data: JSON.stringify({
            invitationCode: inviteCode,
            name: this.userInfo.nickName ? encodeURIComponent(this.userInfo.nickName) : '',
            avatar: this.userInfo.avatar,
          }),
        },
        options: {
          carryRoleFlag: !forbiddenRequireRole,
        },
      });

      console.log(' public helpOrInvitedFunc callback response', response);
      const { ret, msg, data = {} } = response;
      if (ret !== 0) {
        this.$alert({ msg });
        this.reportFunc('assist', { status: '0' });

        return false;
      }
      const { ret: resRet, msg: resMsg } = data;
      if (resRet !== 0) {
        this.$alert({ msg: resMsg });
        this.reportFunc('assist', { status: '0' });

        return false;
      }
      this.refreshQua(); // 刷新资格
      this.closeShowInvitedDialog();
      if (withoutShowSuccessInvitedDialog === true) {
        console.log('不需要助力成功的弹窗');
      } else {
        this.showSuccessInvitedDialog = true;
      }

      this.reportFunc('assist', { status: '1' });
    },
    async initialize() {
      console.log('this.configurationData in tgclub-user-invite-share-with-extra-guide = 1.0.0 ', this.configurationData);
      if (this.$isInEditor) return;
      //   这里暂时不解决   跨业务调用拉起app 走默认业务拉起app
      this.$refs.button.setClickHandler(this.invite, {
        forceApp: this.forceAppShare,
        forceLogin: true,
        forceRole: this.configurationData.forceRole,
      });
      const { closeShareBtn = false }  = this.configurationData;
      this.$onLogined(async () => {
        // 处理是否有邀请码|应邀
        await this.HandleInviteCode();
        /**
         *关闭对应业务的分享按钮
         */
        if (closeShareBtn) {
          console.log('关闭对应业务分享'); // 如果配置的话
          this.$ast.disableAPPShare();
        }
      });
    },
    // 判断应邀的地方
    // const FORCE_INVITED_DEVICE_INSIDE_APP = 1; // 只能在端内触发应邀
    // const FORCE_INVITED_DEVICE_OUTSIDE_APP = 2;// 只能在端外触发应邀
    // const FORCE_INVITED_BOTH_SIDE_DEVICE = 3;//  在端内外触发应邀
    checkAccessInvitedDevice() {
      let  { forceDeviceHelpInvitedType = FORCE_INVITED_BOTH_SIDE_DEVICE } = this.configurationData;
      forceDeviceHelpInvitedType =  parseInt(forceDeviceHelpInvitedType, 10);
      if (this.$ast.isAPP() && forceDeviceHelpInvitedType === FORCE_INVITED_DEVICE_INSIDE_APP) {
        return true;
      }
      if (!this.$ast.isAPP() && forceDeviceHelpInvitedType === FORCE_INVITED_DEVICE_OUTSIDE_APP) {
        return true;
      }
      // 如何两个都可以
      return forceDeviceHelpInvitedType === FORCE_INVITED_BOTH_SIDE_DEVICE;
    },
    // 根据邀请码获取邀请信息
    async HandleInviteCode() {
      // 不是应邀模式
      if (!this.isHasSettingInvitedAccess) {
        console.log('当前不是应邀模式', this.isHasSettingInvitedAccess);
        return false;
      }
      const canAccessInvited  = this.checkAccessInvitedDevice();
      console.log('判定当前环境app 内还是 app 外 可 应邀 canAccessInvited =', canAccessInvited);
      if (canAccessInvited === false) {
        return  false;
      }

      const inviteCode = common.tool.getQueryparams('c_invite_code') || '';
      this.inviteCode = inviteCode;
      if (!inviteCode) {
        return false;
      }
      const inviteSelf = this.configurationData?.inviteSelf || 'no'; // inviteSelf是一个字符串,(是否可以自己邀请自己 no:否 yes:是 默认:否)
      const params = {
        code: inviteCode,
        can_invitation_self: inviteSelf,
      };
      console.log('params = ', params);

      let response = {};
      if (!!this.configurationData.getInviteInfoFlowID) {
        // 如果配置了
        response = await this.flowRequest({
          flowId: this.configurationData.getInviteInfoFlowID,
          params,
        });
      } else {
        response = await baseComponents.Apis.User.getInviteInfoNewVersion(params);
      }
      console.log('response GetInviteInfo ', response);
      const { ret, data = {}, msg } = response;
      if (ret !== 0) {
        this.$alert({ msg: msg || '获取邀请码失败' });
        this.reportFunc('assist', { status: '0' });
        return false;
      }
      const { status = 0, info = {} } = data || {};
      const infoMsg = info || {};
      const { custom_key: queryCodeCustomKey = '' } = infoMsg;
      const { customKey } = this.configurationData;
      if (customKey && customKey !== queryCodeCustomKey) {
        console.warn('当前组件配置自定义标识key不匹配，不进行应邀 queryCodeCustomKey ', queryCodeCustomKey, 'customKey = ', customKey);
        return  false;
      }


      const extMsg = infoMsg.ext && typeof infoMsg.ext === 'string' ? JSON.parse(infoMsg.ext) : {};
      //  status的几种含义:
      // 0:正常
      // 1:自己邀请自己 （can_invitation_self传yes，自己邀请自己也会返回0）
      // 2:已助力
      // 3:链接已过有效期
      if (status === 3) {
        console.warn('邀请码已经失效', extMsg, 'status = ', status);
        return false;
      }
      if (status === 1) {
        console.warn('自己不邀请自己', extMsg, 'status = ', status);
        return false;
      }
      const { needNoPopIfInvited = true } = this.configurationData;
      if (status === 2) {
        this.isHelp = true;
        if (needNoPopIfInvited  === true) {
          console.warn('自己不邀请自己&& 并且已助力', extMsg, 'status = ', status);
          return false;
        }
        // 判断助力满后是否展示助力弹窗this.isEnabledInvited = false 没资格
        if (!this.isEnabledInvited && !this.handleAssistancePopupDisplay) {
          console.warn('助力次数已达上限');
          return response;
        }
        if (extMsg.name === '当前游戏账户') {
          this.inviteInfo.inviter_name = '';
          this.inviteInfo.avatar = '';
        } else {
          this.inviteInfo.inviter_name = extMsg.name || '';
          this.inviteInfo.avatar = extMsg.avatar || '';
        }
        this.openShowInvitedDialog();
        return response;
      }
      if (status !== 0) {
        console.warn('其他错误 invite check fail  for self check  invite info Ext =', extMsg, 'status = ', status);
        return false;
      }
      if (extMsg.name === '当前游戏账户') {
        this.inviteInfo.inviter_name = '';
        this.inviteInfo.avatar = '';
      } else {
        this.inviteInfo.inviter_name = extMsg.name || '';
        this.inviteInfo.avatar = extMsg.avatar || '';
      }
      // 如果是俱乐部应邀模式，进入俱乐部应邀前置流程
      if (this.configurationData.isClubInvite === true) {
        this.clubInvitedCheck();
        return response;
      }

      this.openShowInvitedDialog();
      return response;
    },

    async clubInvitedCheck() {
      // 俱乐部应邀前置判断
      const { clubInviteFlowId = 0 }  = this.configurationData;
      if (clubInviteFlowId === 0) {
        return false;
      }

      const response = await this.flowRequest({
        flowId: this.configurationData.clubInviteFlowId,
        params: {
          invitationCode: this.inviteCode,
          role: this.roleInfo,
        },
      });
      const { ret, msg, data = {} } = response;
      if (ret !== 0) {
        this.$alert({ msg });
        return false;
      }
      if (data.iStatus === 9001) {
        this.joinedClub = true;
      }
      this.showClubInvitedDialog = true;
      this.reportFunc('assist', { status: '3' }); // 临时增加埋点,status为3代表俱乐部应邀弹窗曝光
    },

    getTimeDiff(endTime, startTime) {
      if (!endTime || !startTime) return 0;
      // eslint-disable-next-line no-param-reassign
      endTime = endTime.replace(/-/g, '/');
      // eslint-disable-next-line no-param-reassign
      startTime = startTime.replace(/-/g, '/');
      const endTimeStamp =  parseInt(new Date(endTime).getTime() / 1000, 10);
      const startTimeStamp =  parseInt(new Date(startTime).getTime() / 1000, 10);
      return  endTimeStamp  - startTimeStamp  > 0 ? endTimeStamp  - startTimeStamp : 0;
    },
    getTimeStamp(time) {
      if (time) {
        // ios 的时间格式需要更改一下
        // eslint-disable-next-line no-param-reassign
        time = time.replace(/-/g, '/');
        return parseInt(new Date(time).getTime() / 1000, 10);
      }
      return parseInt(new Date().getTime() / 1000, 10);
    },
    // 判断
    async handleInviteClick() {
      // # 需要邀请码
      const { cycle = 'custom', inviteShareStartTime, inviteShareEndTime, customKey,
        isNeedGameOpenid = false, noneStartInvitedShareMsg } = this.configurationData;
      if (cycle === 'custom' && inviteShareStartTime &&   this.getTimeStamp(inviteShareStartTime) > this.getTimeStamp()) {
        return  this.$alert({ msg: noneStartInvitedShareMsg || '邀请时间未开启' });
      }
      const params = {
        gid: this.$actInfo?.gid || 0,
        cycle: cycle || 'custom', // day 本天  week 本周  month 本月 custom 自定义
        expire_time: this.getTimeDiff(inviteShareEndTime, inviteShareStartTime), // custom 过期时间 秒
        // 没有开放功能
        custom_key: customKey ||  `${this.$actInfo?.activity_id}`, //  自定义 key 默认活动号
        // 没有开放功能 预留字段 0 不需要游戏openid  1 需要游戏openid
        is_need_game_openid: isNeedGameOpenid ?  1 : 0,
        ext: JSON.stringify({
          name: this.userInfo.nickName || '',
          avatar: this.userInfo.avatar || 'https://game.gtimg.cn/images/js/img/lottery/default_head.png',
          activityId: `${this.$actInfo?.activity_id}`,
        }),
      };
      console.log('-----------getInviteCode access params 参数是 = ---------- ', params);
      console.log('getInviteCode and this.userInfo  =  ', this.userInfo);

      let response = {};
      if (!!this.configurationData.getInviteCodeFlowID) {
        // 如果配置了
        response = await this.flowRequest({
          flowId: this.configurationData.getInviteCodeFlowID,
          params,
        });
      } else {
        response = await baseComponents.Apis.User.getInviteCodeNewVersion(params);
      }

      console.log('getInviteCode response = ', response);
      const { ret, data = {} } = response || {};
      const { code: inviteCode = '' } = data;
      if (ret !== 0 || !inviteCode) {
        this.toast('获取邀请码失败');
        this.selfInviteCode = '';
        return false;
      }
      this.selfInviteCode = inviteCode;
      return true;
    },
    async invite() {
      // 前置条件判断
      const invitePreCheckRes = await this.handleInvitePreCondition();
      if (!invitePreCheckRes) {
        return false;
      }
      if (this.isInvite) {
        // 应邀模式 获取邀请码
        const getInviteCodeRes =  await this.handleInviteClick();
        if (!getInviteCodeRes) {
          return  false;
        }
      }
      let link = common.tool.setUrlParam(
        'c_invite_code',
        this.selfInviteCode,
        this.configurationData.link || this.shareConfig.link || window.location.href,
      );
      // 当打开的活动url上携带了via,via_source,trace_id参数时，透传当前活动的via,via_source,trace_id到分享链接上
      link = common.tool.passThroughUrlParam(link, ['via', 'trace_id', 'via_source'], true);
      link = common.tool.setUrlParam('t', `${new Date().getTime()}`, link);
      this.doShareSetting(link);
    },
    doShareSetting(link) {
      console.log('doShareSetting link = ', link);
      const shareNewConfig = {
        title: this.configurationData.title || this.shareConfig.title,
        link,
        desc: this.configurationData.desc || this.shareConfig.desc, // 分享标题，默认为活动页面标题（可手动调整）, //分享活动简介
        icon: this.configurationData.icon || this.shareConfig.icon, // 分享后朋友看到的图标
      };
      let callback = null;
      if (this.$ast.isAPP()) {
        const makeCallBackFunc =  this.$ast.makeAPPShareCallBack();
        if (typeof  makeCallBackFunc  ===  'function') {
          callback  =  makeCallBackFunc.apply(this, [this.componentCallBackFunc, this]);
        }
        console.log('makeCallBackFunc = ', makeCallBackFunc, 'callback=', callback);
      }
      if (!callback) {
        callback = this.componentCallBackFunc.bind(this);
      }
      shareNewConfig.callback = callback;
      this.reportFunc('share', {});
      this.$ast.setAPPShare(shareNewConfig);
      if (this.$ast.isAPP()) {
        this.$ast.goAPPShare(shareNewConfig);
      } else {
        this.doShare(shareNewConfig);
      }
    },
    reportFunc(key, eventData) {
      if (typeof this.reportClickRaw === 'function') {
        const params = {
          ceibaComponentId: `${this.cid}`,
          ceibaComponentUid: this.uid,
          ceibaComponentUname: this.uname,
          eventKey: key,
          eventData,
        };
        this.reportClickRaw(params);
        console.log(`reportFunc ${key}  report data =`, params);
      }
    },
    // 任务按钮
    doTaskAction(taskIdRemarkKey) {
      if (taskIdRemarkKey) {
        // eslint-disable-next-line no-underscore-dangle
        this.__taskIdRemarkKey__ = taskIdRemarkKey;
        this.invite();
      }
    },
    finishTaskAction(value) {
      // eslint-disable-next-line no-underscore-dangle
      if (this.__taskIdRemarkKey__) {
        // eslint-disable-next-line no-underscore-dangle
        window[this.__taskIdRemarkKey__] = value;
      }
    },
    // 分享回调
    async componentCallBackFunc() {
      console.log('run componentCallBackFunc doShare callback and this.callBackFlowId = ', this.callBackFlowId);
      this.finishTaskAction(1);
      if (this.callBackFlowId > 0) {
        const response = await this.flowRequest({
          flowId: this.callBackFlowId,
          params: {
            role: this.roleInfo,
          },
        });
        this.refreshQua(); // 刷新礼包
        const { callBackSuccessTips = '' } = this.configurationData;
        if (callBackSuccessTips) {
          const { ret = 0, data = {} } = response || {};
          const  { ret: resRet = 0 } = data;
          if (ret === 0 && resRet === 0) {
            return this.$alert({ msg: callBackSuccessTips });
          }
        }
        console.log('run componentCallBackFunc doShare callback and response = ', this.callBackFlowId, response);
      }
    },
    confirmShowSuccessConfirm() {
      const { showSuccessInvitedLink } = this.configurationData;
      if (!showSuccessInvitedLink) {
        this.showSuccessInvitedDialog = false;
        return;
      }
      // 如果没在app,跳app
      if (this.configurationData.forceApp && !this.$ast.isAPP()) {
        // 如果没有跳转链接,直接跳app活动页
        if (!showSuccessInvitedLink) {
          this.$ast.gotoAPP();
          return;
        }
        this.$ast.gotoAPP(showSuccessInvitedLink);
        return;
      }
      // 如果有跳转链接,跳转
      setTimeout(() => {
        let link = showSuccessInvitedLink;
        // 当打开的活动url上携带了via,via_source,trace_id参数时，透传当前活动的via,via_source,trace_id到分享链接上
        link = common.tool.passThroughUrlParam(link, ['via', 'trace_id', 'via_source']);
        window.location.href = link;
      }, 500);
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
